// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c787114","453":"b2f273f7","455":"277b3fe3"}[chunkId] + ".chunk.js";
};